
(function (mod){ //[HyperMD] UMD patched!
  /*commonjs*/  ("object"==typeof exports&&"undefined"!=typeof module) ? mod(null, exports, require("../../addon/fold-html")) :
  /*amd*/       ("function"==typeof define&&define.amd) ? define(["require","exports","../../addon/fold-html"], mod) :
  /*plain env*/ mod(null, (this.HyperMD.PreviewFeatureWidget = this.HyperMD.PreviewFeatureWidget || {}), HyperMD.FoldHTML);
})(function (require, exports, fold_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = (function (md) {
        var renderWidget = function (content) {
            content = content
                .replace(/^<!--\s*/, "")
                .replace(/-->$/, "")
                .trim();
            var widgetName;
            var widgetAttributes = {};
            var firstSpaceMatch = content.match(/\s/);
            var firstSpace = firstSpaceMatch ? firstSpaceMatch.index : -1;
            if (firstSpace > 0) {
                widgetName = content.slice(0, firstSpace).trim().replace(/^@/, "");
                try {
                    widgetAttributes = JSON.parse("{" +
                        content
                            .slice(firstSpace + 1)
                            .trim()
                            .replace(/-\\->/g, "-->")
                            .replace(/<!\\--/g, "<!--")
                            .replace(/\\\|/g, "|") +
                        "}");
                }
                catch (error) {
                    widgetName = "error";
                    widgetAttributes = { message: error.toString() };
                }
            }
            else {
                widgetName = content.trim().replace(/^@/, "");
            }
            if (widgetName) {
                return "<span class=\"vickymd-widget\" data-widget-name='" + widgetName + "' data-widget-attributes='" + JSON.stringify(widgetAttributes) + "'></span>";
            }
        };
        var oldHTMLInlineRenderer = md.renderer.rules.html_inline;
        md.renderer.rules.html_inline = function (tokens, idx, options, env, slf) {
            var content = tokens[idx].content.trim();
            if (content.match(/^<!--\s*@/) && content.match(/-->$/)) {
                return renderWidget(content);
            }
            else {
                var html = oldHTMLInlineRenderer(tokens, idx, options, env, slf);
                if (fold_html_1.defaultChecker(html)) {
                    return html;
                }
                else {
                    return "";
                }
            }
        };
        var oldHTMLBlockRenderer = md.renderer.rules.html_block;
        md.renderer.rules.html_block = function (tokens, idx, options, env, slf) {
            var content = tokens[idx].content.trim();
            if (content.match(/^<!--\s*@/) && content.match(/-->$/)) {
                return renderWidget(content);
            }
            else {
                var html = oldHTMLBlockRenderer(tokens, idx, options, env, slf);
                if (fold_html_1.defaultChecker(html)) {
                    return html;
                }
                else {
                    return "";
                }
            }
        };
    });
});
